import { createSlice } from '@reduxjs/toolkit';
import { SignStatus } from 'interface/walletButtonInterface';
// TODO fix no cycle error
// eslint-disable-next-line import/no-cycle
import { RootState } from '../store';

interface WalletPopupState {
  isOpen: boolean
  signStatus: SignStatus
}

const initialState: WalletPopupState = {
  isOpen: false,
  signStatus: 'idle',
};

export const walletPopupSlice = createSlice({
  name: 'walletPopupSlice',
  initialState,
  reducers: {
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },

    openPopup: (state) => {
      state.isOpen = true;
    },

    closePopup: (state) => {
      state.isOpen = false;
    },

    setSignStatus: (state, action: { payload: SignStatus }) => {
      state.signStatus = action.payload;
    },
  },
});

export const {
  setIsOpen, openPopup, closePopup, setSignStatus,
} = walletPopupSlice.actions;

export const walletPopupSelector = (state: RootState) => state.walletPopup;

export default walletPopupSlice.reducer;
